import { InputNumber } from 'rsuite'
import { getIn } from 'formik'
import { FormikInputs } from './interfaces'

function TextInputNumber<V>(
  props: Readonly<FormikInputs<V>>
): React.ReactElement {
  const { formik, placeholder = '', isDisabled, name, ...rest } = props

  const fieldValue = getIn(formik?.values, name) ?? ''

  return (
    <InputNumber
      scrollable={false}
      name={name}
      data-testid={name}
      value={
        typeof fieldValue === 'string' || typeof fieldValue === 'number'
          ? fieldValue
          : ''
      }
      disabled={isDisabled}
      placeholder={placeholder}
      onChange={(value: string | number | null) => {
        formik?.setFieldValue(name, value)
      }}
      {...rest}
    />
  )
}

export default TextInputNumber
